module.exports = __webpack_public_path__ + "static/media/flaggedContent.ea01492b.png";